import React from 'react'

import { user } from '../../core/controllers/user';
import OwnersList from '../../components/Owners/OwnersList';
import NavLink from '../../components/Routes/NavLink';
import { owners } from '../../core/controllers/Owners'
import PayoutsList from '../../components/Payouts/PayoutsList';
import { TabGroup } from '../../helpers/Tabs/TabGroup';
import { Tab } from '../../helpers/Tabs/Tab';

export default class OwnersTemplate extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            owners: null,
            numOwners: 0,
            initializedDatePicker: false,
            startDate: moment(moment().subtract(30, 'day').format("YYYY-MM-DD")),
            endDate: moment(moment().format("YYYY-MM-DD")),
        };
    }

    componentDidMount() {
        var self = this;
        owners.getOwners(function(response) {
            self.setState({
                owners: response.data,
                numOwners: response.data.length,
            })
        });
    }

    handleTabChange(index) {
      if (this.state.initializedDatePicker === false) {
        var self = this;
        if (document.getElementsByClassName('daterange')[0]) {
          jQuery('.daterange').daterangepicker({
              opens: 'center',
              "startDate": self.state.startDate,
              "endDate": self.state.endDate,
              "showDropdowns": true,
              "drops": "down",
              "minYear": Number(moment().format("YYYY")) - 3,
              "maxYear": Number(moment().format("YYYY")),
              "locale": {
                  "format": 'MMM Do, YYYY'
              }
          },  function(start, end) {
              self.onDateRangePick(start, end)
          });
        }
        this.setState({
          initializedDatePicker: true
        })
      }
    }

    onDateRangePick(start, end) {
        this.setState({
            startDate: start,
            endDate: end
        }, () => {
        });
    }

    reload() {
        this.forceUpdate();
    }

    render(){
        const startDate             = this.state.startDate.format("MMM Do, YYYY");
        const endDate               = this.state.endDate.format("MMM Do, YYYY");
        const datepicker = (
          <div class='row'>
            <div class='col-md-3 col-sm-6 col-xs-12'>
              <div class='form-group'>
                <label
                  for='date-range'
                  style={
                    window.innerWidth < 768
                      ? { color: 'black' }
                      : { color: '#FFFFFF' }
                  }
                >
                  Select Date Range
                </label>
                <input
                  type='button'
                  class='form-control daterange'
                  id='daterange'
                  value={startDate + ' - ' + endDate}
                  onChange={this.onDateRangePick.bind(this)}
                  disabled={false}
                />
              </div>
            </div>
          </div>
        )
        const start = this.state.startDate
        const end = this.state.endDate
        return (
            <div>
                {this.state.numOwners > 0 ? (
                <div>
                    <div class="row">
                        <div class="main-page-header-row col-md-12">
                            <div class="col-md-3 col-sm-6 col-xs-6">
                                <span class="main-page-header-title">Owners</span>
                            </div>
                            <div class="col-md-2 col-md-offset-7 col-sm-6 col-xs-6">
                                <NavLink to={"/owner/new"}>
                                    <button type="button" id="add-owner" data-loading-text="Loading..." class="btn btn-info btn-fill pull-right" autoComplete="off">
                                        Add Owner
                                    </button>
                                    <div class="clearfix"></div>
                                </NavLink>
                            </div>
                        </div>
                    </div>
                    <TabGroup indexOverride={this.props.payoutsActive && 1} noteActiveTab={this.handleTabChange.bind(this)}>
                        <Tab title="overview">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="card">
                                        <div class="header col-md-6 col-sm-12 col-xs-12">
                                            <h4 class="title">Owner Management</h4>
                                            <p class="category">Keep track of your owners & their properties.</p>
                                        </div>
                                        <OwnersList />
                                    </div>
                                </div>
                            </div>
                        </Tab>
                        <Tab title="payouts">
                            {datepicker}
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="card">
                                        <div class="header col-md-6 col-sm-12 col-xs-12">
                                            <h4 class="title">Payout Management</h4>
                                            <p class="category">Manage payouts to your owners.</p>
                                        </div>
                                        <PayoutsList start={start} end={end} />
                                    </div>
                                </div>
                            </div>
                        </Tab>
                    </TabGroup>
                </div>
                ) : (
                    <div>
                        <div style={{textAlign: "center"}}>
                            <div class="row">
                                <div class="main-page-header-row col-md-12">
                                    <div class="row">
                                        <span class="main-page-header-title">No Owners Yet</span>
                                    </div>
                                    <div class="row" style={{marginTop: "10px"}}>
                                        <NavLink to={"/owner/new"}>
                                            <button type="button" id="add-owner" data-loading-text="Loading..." class="btn btn-info btn-fill" autoComplete="off">
                                                Add Owner
                                            </button>
                                            <div class="clearfix"></div>
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12" style={{backgroundImage: "url('/assets/img/lead.png')", backgroundRepeat: 'no-repeat', backgroundPosition: 'top', backgroundSize: 'contain', minHeight: '560px'}}></div>
                </div>
                )} 
            </div>
        )
    }
};



// WEBPACK FOOTER //
// app/views/Owners/Owners.jsx